export default __webpack_public_path__ + "static/the-gables-homepage-loop-video-8e7b0e44308346ffdf703a864c8e57dc.mp4";